import { ClientApp } from "models";
import { Action } from "redux";

export type SelectApp = "SELECT_APP";
export const SELECT_APP: SelectApp = "SELECT_APP";

export interface SelectAppAction extends Action {
    type: SelectApp;
    payload: {
        app: ClientApp;
    };
}

export function selectApp(app: ClientApp): SelectAppAction {
    return {
        payload: {
            app: app as ClientApp
        },
        type: SELECT_APP
    };
}
